import React, {Component} from 'react';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import pathOr from 'ramda/src/pathOr';
import {guid} from '@ultradent/utilities/Guid';
import Button from '../../Button';
import Icon from '../../Icon';
import SkeletonElement from '../../SkeletonElement';
import Show from '../../Show';

const styles = {
    wrap: 'input-group search-field-wrapper'
}

const styleCloseButton = {
    zIndex: 1,
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.5rem',
    color: '#303030'
};

class SearchInput extends Component {

    static defaultProps = {
        placeholder: 'Search',
        submitActionLabel: 'Search',
        label: 'Search',
        showSubmitAction: false,
        showLabel: false,
        allowClear: true
        // id: `search-suggestions-${Math.floor( Math.random() * 10000 )}`
    };

    constructor ( props ) {
        super( props )

        this.id = this.props.id || `search-suggestions-${guid()}`;
    }

    onInput = e => {
        invoke( this.props.search, 'onInput', e.target.value, e );
    };
    onKeyPress = e => {
        invoke( this.props.search, 'onKeyPress', e.which, e );
    };
    onKeyDown = e => {
        invoke( this.props.search, 'onKeyDown', e.which, e );

        if ( e.which === 13 ) {
            this.input.blur();
            invoke( this.props.search, 'onEnter', e );
        }
    };
    onKeyUp = e => {
        invoke( this.props.search, 'onKeyUp', e.which, e );
    };
    onFocus = e => {
        invoke( this.props.search, 'onFocus', e );
    };
    onBlur = e => {
        invoke( this.props.search, 'onBlur', e )
    };
    onClear = e => {
        invoke( this.props.search, 'onClear', e );
        setTimeout( () => this.input.focus(), 10 );
    };
    onClickSubmit = e => {
        invoke( this.props.search, 'onSubmit', e );
    }

    render () {
        const {
            label,
            showLabel,
            placeholder,
            allowClear,
            large,
            showSubmitAction,
            submitActionLabel,
            roundedTextField,
            search,
            labelClassName,
            inputClassName,
            className,
            prependSlot,
            ...restProps
        } = this.props;

        const query = pathOr( '', ['query'], search );
        const transientQuery = pathOr( '', ['transientQuery'], search );

        const inputClassNameCx = cx(
            'w-full no-ms-clear',
            {
                'input-field-lg': large,
                'rounded-l-full': roundedTextField && !prependSlot
            },
            inputClassName
        );
        const inputAppendClassName = cx(
            'input-group-text',
            {'rounded-r-full': roundedTextField}
        );

        return (
            <div className={cx( styles.wrap, className )}>
                <Show when={prependSlot}>
                    <div className="input-group-prepend">
                        {prependSlot}
                    </div>
                </Show>
                <div className="input-group-append">
                    {showSubmitAction
                        ? <Button className={cx( inputAppendClassName, 'button sm tertiary' )}
                                  onClick={this.onClickSubmit}
                                  icon={() => <Icon name="Search" className="mr-1" width="16" height="16"/>}
                                  title={submitActionLabel}>
                            <span>{submitActionLabel}</span>
                        </Button>
                        : <span className={inputAppendClassName}>
                            <Icon name="Search" width="16" height="16"/>
                        </span>
                    }
                </div>
                <div className="relative input-group-input">
                    <label htmlFor={this.id} className={cx( labelClassName, {hidden: !showLabel} )}>{label}</label>
                    <input
                        id={this.id}
                        data-testid="search-query-field"
                        ref={ref => this.input = ref}
                        className={inputClassNameCx}
                        type="text"
                        value={transientQuery || query}
                        placeholder={placeholder}
                        onInput={this.onInput}
                        onKeyPress={this.onKeyPress}
                        onKeyDown={this.onKeyDown}
                        onKeyUp={this.onKeyUp}
                        onFocus={this.onFocus}
                        autoComplete="off"
                        autoCapitalize="off"
                        autoCorrect="off"
                        {...restProps}
                    />
                    {(allowClear && query.length > 0) &&
                        <span
                            onClick={this.onClear}
                            style={styleCloseButton}>&times;</span>
                    }
                </div>
            </div>

        );
    }
}

SearchInput.Skeleton = ( {className} ) =>
    <div className={cx( styles.wrap, className )}>
        <SkeletonElement className="rounded-full h-10 w-full"/>
    </div>

export default SearchInput;
